var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CognitoUser } from 'amazon-cognito-identity-js';
// import { IIdentityStore } from '@liquid-state/iwa-identity/dist/store';
import { Identity } from '@liquid-state/iwa-identity';
/**
 * An aws specific identity which returns valid credentials from Cognito.
 */
var AWSIdentity = /** @class */ (function () {
    function AWSIdentity(name, credentials) {
        this.name = name;
        this.credentials = credentials;
        this.identityMap = new Map();
        this.isAuthenticated = Boolean(name);
    }
    Object.defineProperty(AWSIdentity.prototype, "identifiers", {
        get: function () {
            if (!this.identityMap.has('sub')) {
                var sub = this.credentials.session.getIdToken().decodePayload().sub;
                this.identityMap.set('sub', sub);
                this.identityMap.set('username', this.credentials.user.getUsername());
                this.identityMap.set('jwt', this.credentials.session.getAccessToken().getJwtToken());
            }
            return this.identityMap;
        },
        enumerable: true,
        configurable: true
    });
    return AWSIdentity;
}());
export { AWSIdentity };
var CognitoIdentityProvider = /** @class */ (function () {
    function CognitoIdentityProvider(userPool) {
        this.userPool = userPool;
    }
    CognitoIdentityProvider.prototype.getIdentity = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, session, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = this.userPool.getCurrentUser();
                        if (!user) {
                            return [2 /*return*/, new Identity(null, null)];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getSession(user)];
                    case 2:
                        session = _a.sent();
                        return [2 /*return*/, new AWSIdentity(user.getUsername(), { user: user, session: session })];
                    case 3:
                        e_1 = _a.sent();
                        console.log(e_1);
                        return [2 /*return*/, new Identity(null, null)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CognitoIdentityProvider.prototype.update = function (name, session, store) {
        if (store === void 0) { store = true; }
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                user = new CognitoUser({
                    Username: name,
                    Pool: this.userPool,
                });
                // This will clear any existing sessions with this userpool and
                // update the currently stored tokens.
                user.setSignInUserSession(session);
                return [2 /*return*/, this.getIdentity()];
            });
        });
    };
    CognitoIdentityProvider.prototype.clear = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                user = this.userPool.getCurrentUser();
                if (user) {
                    user.signOut();
                }
                return [2 /*return*/];
            });
        });
    };
    CognitoIdentityProvider.prototype.getSession = function (user) {
        return new Promise(function (resolve, reject) {
            user.getSession(function (err, session) {
                err ? reject(err) : resolve(session);
            });
        });
    };
    return CognitoIdentityProvider;
}());
export default CognitoIdentityProvider;
//# sourceMappingURL=identity.js.map